class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.classList.add('active');
    this.querySelector('.modal-overlay').classList.add('active');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => this.notification.classList.add('active'), 300)

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, {once: true});

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.classList.remove('active');
    this.notification.classList.remove('active');
    this.querySelector('.modal-overlay').classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      this.removeExtraProductsFromCount();
    }));


    if (this.header) this.header.reveal();
    this.open();
    
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  async getCart() {
    return fetch(`${routes.cart_url}`, {...fetchConfig()})
      .then((response) => response.json())
      .catch((e) => {
      console.error(e);
    });
  }

  

  async removeExtraProductsFromCount() {
    let cart = await this.getCart();
    let cartItems = cart.items;
    let cartCount = cart.item_count;

    console.log(cartItems);

    const matchItem1 = cartItems.find(item => item.id == extraProduct1VariantId);
    const matchItem2 = cartItems.find(item => item.id == extraProduct2VariantId);
  
    let quantityToRemove = 0;
    if (matchItem1 && matchItem2) {
        quantityToRemove = matchItem1.quantity + matchItem2.quantity;
    } else if (matchItem1) {
        quantityToRemove = matchItem1.quantity;
    } else if (matchItem2) {
        quantityToRemove = matchItem2.quantity;
    }

    const cartIconBubble = document.querySelector('.cart-count-bubble span:first-child');
    const cartCountButtonNotification = document.querySelector('.cart-count-button-notification');
    cartCountButtonNotification.innerHTML = `(${cartCount - quantityToRemove})`;
    cartIconBubble.innerHTML = cartCount - quantityToRemove;

  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
